<div class="test" #formContainer *ngIf="!uploading">
    <div class="container-fluid quiz" *ngIf="isEng  && currentStep">
        <div class=" quiz-question">
            <div class="container">
                <h3 [innerHTML]="currentStep.label | safeHtml: 'html'">

                </h3>
            </div>
        </div>
        <form class="container" (ngSubmit)="submit()">


            <div class="quiz-item">
                <formly-form [(model)]="data" [fields]="currentStep?.questions"
                             [form]="form"></formly-form>
            </div>

        </form>
        <div class="quiz-nav">
            <div>
                <button class="nav-button prev-button" *ngIf="steps.length>1" type="button" (click)="showPrevStep()">
                    <img src="./assets/img/arrow-prev-icon.png" alt="previous-icon">
                    <span>Previous step</span>
                </button>
            </div>

            <button class="nav-button proceed-button" [ngClass]="{'invalid-form': !form.valid}" (click)="submit()">
                <span>Proceed</span>
                <img src="../assets/img/arrow-next-icon.png" alt="next-icon">
            </button>
        </div>
    </div>
    <div class="container-fluid quiz" *ngIf="!isEng  && currentStep">
        <div class=" quiz-question">
            <div class="container">
                <h3 [innerHTML]="currentStep.label | safeHtml: 'html'">

                </h3>
            </div>
        </div>
        <form class="container" (ngSubmit)="submit()">


            <div class="quiz-item">
                <formly-form [(model)]="data" [fields]="currentStep?.questions"
                             [form]="form"></formly-form>
            </div>

        </form>
        <div class="quiz-nav">
            <div>
                <button class="nav-button prev-button" *ngIf="steps.length>1" type="button" (click)="showPrevStep()">
                    <img src="./assets/img/arrow-prev-icon.png" alt="previous-icon">
                    <span>Попередній крок</span>
                </button>
            </div>

            <button class="nav-button proceed-button" [ngClass]="{'invalid-form': !form.valid}" (click)="submit()">
                <span>Продовжити</span>
                <img src="../assets/img/arrow-next-icon.png" alt="next-icon">
            </button>
        </div>
    </div>

</div>
<ng-container *ngIf="uploading">
    <div class="preloader-wrapper uploading">
        <div class="position-relative" *ngIf="isEng">
            <lib-preloader [loading]="uploading" [text]="uploadingText"></lib-preloader>
        </div>
    </div>
</ng-container>

<lib-preloader [loading]="loading" [text]="configuringText"></lib-preloader>
